<template>
  <div class="ag-draft-review p-4" v-if="draftReview && draftReview !== 'null'">
    <ul class="ag-draft-review-list">
      <li>
        <span class="lighttext">{{$t("blockAction")}}</span>
        <span class="value">{{draftReview.blockType}}</span>
      </li>
      <li>
        <span class="lighttext">{{$t("Actor")}}</span>
        <span class="value">{{draftReview.actorName}}</span>
      </li>
      <li>
        <span class="lighttext">{{$t("Target")}}</span>
        <span class="value">{{draftReview.targetName}}</span>
        <span class="raw" v-for="(item, key) in ancestorList" :key="key">
          <!-- {{ancestorList}} -->
        </span>
      </li>
      <li>
        <span class="lighttext">{{$t("eventId")}}</span>
        <span class="value">{{draftReview.eventId}}</span>
      </li>
    </ul>
    <ul class="ag-draft-review-list wrap">
      <li class="form-group">
        <select name="" id="" class="form-control" v-model="draftUpdate.riskLevel">
          <option value="">{{$t("selectRiskLevel")}}</option>
          <option v-for="(item, key) in riskLevels" :key="key" :value="item.value">{{item.key}}</option>
        </select>
      </li>
      <li class="form-group">
        <select name="" id="" class="form-control" v-model="draftUpdate.permissionLevel">
          <option v-for="(item, key) in permissionLevels" :key="key" :value="item.value">{{item.key}}</option>
        </select>
      </li>
      <li class="form-group">
        <label for="checkbox1">
          <input type="checkbox" id="checkbox1" name="checkbox1" v-model="draftUpdate.allowSigned">
          {{$t("allowSigned")}}
        </label>
      </li>
      <li class="form-group">
        <label for="checkbox2">
          <input type="checkbox" id="checkbox2" name="checkbox2" v-model="draftUpdate.allowTpl">
          {{$t("allowTPL")}}
        </label>
      </li>
      <li class="form-group">
        <label for="checkbox3">
          <input type="checkbox" id="checkbox3" name="checkbox3" v-model="draftUpdate.memoryGuard">
          {{$t("memoryGuard")}}
        </label>
      </li>
    </ul>
    <ul class="ag-draft-review-list dropList">
      <li class="form-group">
        <label for="message">{{$t("notes")}}</label>
      </li>
      <li class="form-group">
        <textarea name="message" id="message" cols="30" rows="3" v-model="draftUpdate.notes" placeholder="Enter a description"></textarea>
      </li>
    </ul>
  </div>
</template>

<script>
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import ProposedUniqueBlocks from "../../helpers/pages/ProposedUniqueBlocks";
import { ref } from "vue";

const store = useStore();
export default {
  name: "ag-draft-review",
  data: () => ({
    draftReview: null,
    draftUpdate: {
      riskLevel: "",
      permissionLevel: 0,
      allowSigned: 0,
      allowTpl: 0,
      memoryGuard: 0,
      notes: null,
    },
  }),
  setup() {

    if (!store.state.general.permissionLevels.length) store.dispatch(GeneralActionTypes.GET_PERMISSION_LEVELS, null);
    if (!store.state.general.reviewStatuses.length) store.dispatch(GeneralActionTypes.GET_REVIEW_STATUSES, null);
    if (!store.state.general.riskLevels.length) store.dispatch(GeneralActionTypes.GET_RISK_LEVELS, null);

    const module = ref(ProposedUniqueBlocks);
    
    return {
      module
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
    },
    'draftUpdate.riskLevel'(value) {
      this.module.models.draftUpdate.riskLevel = value;
    },
    'draftUpdate.permissionLevel'(value) {
      this.module.models.draftUpdate.permissionLevel = value;
    },
    'draftUpdate.allowSigned'(value) {
      this.module.models.draftUpdate.allowSigned = value;
    },
    'draftUpdate.allowTpl'(value) {
      this.module.models.draftUpdate.allowTpl = value;
    },
    'draftUpdate.memoryGuard'(value) {
      this.module.models.draftUpdate.memoryGuard = value;
    },
    'draftUpdate.notes'(value) {
      this.module.models.draftUpdate.notes = value;
    },
  },
  methods: {
    getList() {
      if (store.state.general.selectedExpandedRow) {
        this.draftReview = store.state.general.selectedExpandedRow;
        if (this.draftReview.ancestorList) {
          this.ancestorList = this.draftReview.ancestorList.map((f) => {
            return f.Path;
          });
        } else {
          console.log(this.draftReview)
        }

        this.permissionLevels = store.state.general.permissionLevels;
        this.reviewStatuses = store.state.general.reviewStatuses;
        this.riskLevels = store.state.general.riskLevels;

        // console.log("permissionLevels =>",this.permissionLevels)
        // console.log("reviewStatuses =>",this.reviewStatuses)
        // console.log("riskLevels =>",this.riskLevels)
      }
    },
  }
};
</script>

<style lang="scss">
#exportJSON {
  margin-left: 0 !important;
  margin-bottom: 1.5rem;
}

.ag-draftReview {
  height: 60vh;
  overflow: auto;
}

.ag-draft-review-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 15px 0;
  flex-wrap: wrap;
}

.ag-draft-review-list.wrap {
  padding-top: 70px;
  justify-content: center;
  align-items: center;
}

.ag-draft-review-list li {
  flex-direction: column;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0 15px;
  flex-grow: 1;
}

.ag-draft-review-list li .lighttext {
  color: #8E8E8E;
  font-size: 14px;
}

.ag-draft-review-list li .value {
  color: #8E8E8E;
  font-size: 30px;
}

.ag-draft-review-list li .raw {
  color: #8E8E8E;
  font-size: 12px;
}

.ag-draft-review-list.dropList {
  flex-direction: column;
  margin-top: 70px;
}

.ag-draft-review-list.dropList li {
  width: 100%;
}

.ag-modal .modal-body {
  background: #f8f8f8;
}

.ag-modal .modal-body textarea {
  border-color: #ddd;
  padding: 15px;
}

.ag-modal .modal-body label {
  color: #8E8E8E;
  font-size: 14px;
  margin: 0;
}
</style>
